module.exports = __webpack_public_path__ + "img/inventory_compressed.14a673a6.jpg";